<video #video autoplay playsinline x-webkit-airplay="false" type="video/mp4" [muted]="muteAudio" [src]="videoUrl() | msTrust: 'resourceurl'"></video>
<ms-loading-indicator />
@if (muteVisible) {
    <span class="video-mute-unmute-button" [ngClass]="muteAudio ? 'theme-sound-mute' : 'theme-sound-loud'" (click)="toggleMute()"></span>
}
